import React from 'react'

const SVG = ({
  style = {},
  fill = '#5F5F5F',
  width = '100%',
  height = '100%',
  className = '',
  viewBox = '0 0 18 13'
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns='http://www.w3.org/2000/svg'
    className={`svg-icon ${className || ''}`}
  >
    <g>
      <path fill={fill} d='M17,5.5H1c-0.6,0-1,0.4-1,1c0,0.6,0.4,1,1,1h16c0.6,0,1-0.4,1-1C18,5.9,17.6,5.5,17,5.5z' />
      <path fill={fill} d='M1,2h16c0.6,0,1-0.4,1-1s-0.4-1-1-1H1C0.4,0,0,0.4,0,1S0.4,2,1,2z' />
      <path fill={fill} d='M17,11H1c-0.6,0-1,0.4-1,1s0.4,1,1,1h16c0.6,0,1-0.4,1-1S17.6,11,17,11z' />

    </g>
  </svg>
)

export default SVG
